import { useLang } from "../context/LanguageContext";

export default function Footer() {
  const { t } = useLang();

  return (
    <footer className="border-t border-slate-200 py-6 px-4 bg-[#F8F7F4]">
      <div className="flex flex-col items-center gap-3">
        <p className="text-xs text-slate-400 text-center">
          <a
            href="https://globalmobility.law/politica-privacidad"
            target="_blank"
            rel="noopener noreferrer nofollow"
            className="hover:text-slate-600 transition-colors"
          >
            {t("footer.privacyPolicy")}
          </a>
          {" · "}
          <a
            href="https://globalmobility.law/terminos-servicio"
            target="_blank"
            rel="noopener noreferrer nofollow"
            className="hover:text-slate-600 transition-colors"
          >
            {t("footer.termsOfService")}
          </a>
          {" · "}
          <a
            href="https://globalmobility.law/politica-cookies"
            target="_blank"
            rel="noopener noreferrer nofollow"
            className="hover:text-slate-600 transition-colors"
          >
            {t("footer.cookiePolicy")}
          </a>
          {" · "}
          <a
            href="https://globalmobility.law/aviso-legal"
            target="_blank"
            rel="noopener noreferrer nofollow"
            className="hover:text-slate-600 transition-colors"
          >
            {t("footer.legalNotice")}
          </a>
        </p>

        <p className="text-xs text-slate-300">{t("footer.copyright")}</p>
      </div>
    </footer>
  );
}
